import { FlujoVentaPaso } from './../../../_models/flujo-venta-paso';
import { TabViewCustom } from './../../../_models/tab-view-custom';
import { Component, Input, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-flujo-venta-monetizacion',
  templateUrl: './flujo-venta-monetizacion.component.html',
  styleUrls: ['./flujo-venta-monetizacion.component.css']
})
export class FlujoVentaMonetizacionComponent implements OnInit {
  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Input() titulo: string;

  tabSeleccionado = "DATGEN";

  constructor() {}

  ngOnInit() {}

  abrirAcordeon(evento: number) {
    switch (evento) {
      case 0: {
        this.tabSeleccionado = "DATGEN";
        break;
      }
      case 1: {
        this.tabSeleccionado = "RESPERXVIN";
        break;
      }
    }
  }
}
